import React, { Component } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { Card, Grid, Statistic } from "semantic-ui-react";
import { Text } from "..";
import { CurrenecyText } from "../text";

interface ISummaryCardType1 extends WithTranslation {
  labelHeader?: string;
  unit?: string;
  labelTop?: string;
  labelBottomLeft?: string;
  labelBottomRight?: string;
  label3rd?: string;
  valueTop?: number;
  valueBottomLeft?: number;
  valueBottomRight?: number;
  value3rd?: number;
  noneBorderRadius?: boolean;
  fluid?: boolean;
  stretched?: boolean;
}

class SummaryCardType1 extends Component<ISummaryCardType1> {
  public render() {
    const {
      labelHeader,
      labelTop,
      labelBottomLeft,
      labelBottomRight,
      label3rd,
      valueTop,
      valueBottomLeft,
      valueBottomRight,
      value3rd,
      unit,
      noneBorderRadius,
      fluid,
      stretched,
    } = this.props;
    const borderRadius = noneBorderRadius ? styles.card : undefined;
    return (
      <Card style={borderRadius} centered fluid={fluid}>
        <Card.Content
          header={<Text size="huge">{labelHeader}</Text>}
          style={styles.headerCard}
        />
        <Card.Content
          style={styles.bodyCard}
          description={
            <Grid celled style={styles.descriptionCard} textAlign="center">
              <Grid.Row columns={1}>
                <Grid.Column>
                  <Statistic size="tiny">
                    {labelTop ? (
                      <Statistic.Label>
                        <Text size="large">{labelTop}</Text>
                      </Statistic.Label>
                    ) : null}
                    <Statistic.Value>
                      <CurrenecyText shade={2} size={"huge"}>
                        {valueTop || 0}
                      </CurrenecyText>
                    </Statistic.Value>
                    <Statistic.Label>
                      <Text size="large">{`(${unit})`}</Text>
                    </Statistic.Label>
                  </Statistic>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row columns={1}>
                <Grid.Column>
                <Statistic size="mini">
                    <Statistic.Label>
                      <Text size="small">{labelBottomLeft}</Text>
                    </Statistic.Label>
                    <Statistic.Value>
                      <CurrenecyText shade={2} size={"tiny"}>
                        {valueBottomLeft || 0}
                      </CurrenecyText>
                    </Statistic.Value>
                    <Statistic.Label>
                      <Text size="small">{`(${unit})`}</Text>
                    </Statistic.Label>
                  </Statistic>
                </Grid.Column>
              </Grid.Row>                
              <Grid.Row columns={2}>
                <Grid.Column stretched={stretched}>
                  <Statistic size="mini">
                    <Statistic.Label>
                      <Text size="small">{labelBottomRight}</Text>
                    </Statistic.Label>
                    <Statistic.Value>
                      <CurrenecyText shade={2} size={"tiny"}>
                        {valueBottomRight || 0}
                      </CurrenecyText>
                    </Statistic.Value>
                    <Statistic.Label>
                      <Text size="small">{`(${unit})`}</Text>
                    </Statistic.Label>
                  </Statistic>
                </Grid.Column>  
                <Grid.Column stretched={stretched}>
                  <Statistic size="mini">
                    <Statistic.Label>
                      <Text size="small">{label3rd || "อื่นๆ"}</Text>
                    </Statistic.Label>
                    <Statistic.Value>
                      <CurrenecyText shade={2} size={"tiny"}>
                        {value3rd || 0}
                      </CurrenecyText>
                    </Statistic.Value>
                    <Statistic.Label>
                      <Text size="small">{`(${unit})`}</Text>
                    </Statistic.Label>
                  </Statistic>
                </Grid.Column>                           
              </Grid.Row>
            
            </Grid>
          }
        />
      </Card>
    );
  }
}

const styles = {
  headerCard: {
    background: "#F3F3F3",
    textAlign: "center",
  },
  bodyCard: {
    padding: 0,
  },
  descriptionCard: {
    margin: 0,
  },
  card: {
    borderRadius: "initial",
  },
};

export default withTranslation()(SummaryCardType1);
